var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"hover-menu__wrapper",on:{"contextmenu":function($event){$event.preventDefault();return _vm.toggleContextMenu.apply(null, arguments)}}},_vm.listeners),[_vm._t("object"),(_vm.contextMenuIsVisible)?_vm._t("menu"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }